import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { StickyNote, PhoneCall, MessageSquare } from "lucide-react";

const KINDS = [
  { k: "note", label: "Note", icon: StickyNote },
  { k: "call", label: "Call", icon: PhoneCall },
  { k: "message", label: "Message", icon: MessageSquare },
];
const CALL_OUTCOMES = ["Connected", "No answer", "Busy", "Wrong number", "Call back later"];
const CHANNELS = ["WhatsApp", "SMS", "Instagram DM", "LinkedIn", "Other"];

export default function LogActivity({ leadId, onLogged, initialKind = "note" }) {
  const [kind, setKind] = useState(initialKind);
  const [text, setText] = useState("");
  const [outcome, setOutcome] = useState(CALL_OUTCOMES[0]);
  const [duration, setDuration] = useState("");
  const [channel, setChannel] = useState(CHANNELS[0]);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!text.trim() && kind !== "call") { toast.error("Write something first"); return; }
    setBusy(true);
    const data = kind === "call" ? { outcome, duration_min: duration ? Number(duration) : null } : kind === "message" ? { channel } : {};
    try {
      await api.post(`/crm/leads/${leadId}/activity`, { kind, text, data });
      setText(""); setDuration("");
      toast.success(`${KINDS.find((x) => x.k === kind).label} logged`);
      onLogged();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="panel-2 p-2.5" data-testid="log-activity">
      <div className="flex gap-1 mb-2">
        {KINDS.map(({ k, label, icon: I }) => (
          <button key={k} onClick={() => setKind(k)} data-testid={`log-kind-${k}`}
            className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors ${kind === k ? "bg-white text-black" : "text-neutral-400 hover:text-white"}`}>
            <I size={12} />{label}
          </button>
        ))}
      </div>
      {kind === "call" && (
        <div className="flex gap-2 mb-2">
          <select className="flex-1 px-2 py-1 rounded border text-xs" value={outcome} onChange={(e) => setOutcome(e.target.value)} data-testid="log-call-outcome">
            {CALL_OUTCOMES.map((o) => <option key={o}>{o}</option>)}
          </select>
          <input type="number" className="w-24 px-2 py-1 rounded border text-xs" placeholder="mins" value={duration} onChange={(e) => setDuration(e.target.value)} data-testid="log-call-duration" />
        </div>
      )}
      {kind === "message" && (
        <select className="w-full mb-2 px-2 py-1 rounded border text-xs" value={channel} onChange={(e) => setChannel(e.target.value)} data-testid="log-msg-channel">
          {CHANNELS.map((o) => <option key={o}>{o}</option>)}
        </select>
      )}
      <textarea rows={2} className="w-full px-2.5 py-1.5 rounded border text-sm" placeholder={kind === "call" ? "Call summary (optional)" : kind === "message" ? "What was sent / received" : "Add a note…"}
        value={text} onChange={(e) => setText(e.target.value)} data-testid="log-text" />
      <div className="flex justify-end mt-2"><button className="btn btn-primary text-xs" onClick={save} disabled={busy} data-testid="log-save">{busy ? "Saving…" : "Log"}</button></div>
    </div>
  );
}
